import { useContext } from 'react';
import { Context as ResponsiveProviderContext } from 'client/components/common/ResponsiveProvider/Context';
import { int } from 'utils/helpers';

type Props = {
	value: number;
	unit?: string;
};

// Render value(px) relative to min boundary of the current media query
// Used for display base size in px for values stored in vw
const RelativeSizeValue = ({ value, unit }: Props) => {
	const { boundaries } = useContext(ResponsiveProviderContext);

	if (!boundaries) {
		return '';
	}

	return `${int((boundaries.min / window.innerWidth) * value)}${unit}`;
};

RelativeSizeValue.defaultProps = {
	unit: '',
};

export default RelativeSizeValue;
